import React from 'react';

import PdfIcon from 'assets/icons/pdf.png';

const Icon = (props) => {
  return (
    <div className="hotspot_icon">
      <img alt="info-icon" src={PdfIcon} style={{ width: '18px' }}></img>
    </div>
  );
};

export default Icon;
